import React from "react";
import TasksPage from "./Tasks";

export default function TodayTasksPage(props) {
  return <TasksPage {...props} isTodayView={true} />;
}
